export const VR_DEPOSIT = 50000;